import "./src/styles/global.css";
// import "@fontsource/poppins/700.css";

import * as React from "react";
import PageTransition from "./src/components/PageTransition";

export const wrapPageElement = ({ element, props }) => (
  <PageTransition element={element} location={props.location} />
);
